module.exports = __webpack_public_path__ + "img/box.6bcbbbf7.png";